module.exports = __webpack_public_path__ + "img/chart-bar.b63870d7.svg";